import React, { useState } from "react";
import { ChevronRight } from "lucide-react";

const ProfileSection = ({ onNavigateToDashboard }) => {
  const [stepIndex, setStepIndex] = useState(0);
  const [expandedSections, setExpandedSections] = useState({
    0: true,
    1: false,
    7: false,
  });

  const steps = [
    {
      title: "Profile Hub",
      level: 0,
      image: "/assets/guide/auth/profile/profile_page.png",
      description: "Manage your OSRS IGNs and clan memberships.",
    },
    { title: "IGN Management", level: 0, isHeader: true, id: 1 },
    {
      title: "Linking IGNs",
      level: 1,
      parentId: 1,
      image: "/assets/guide/auth/profile/link_new_ign.png",
      description:
        "This is what pops up when you click the 'LINK NEW IGN(s)' button.",
    },
    {
      title: "IGN Filled",
      level: 1,
      parentId: 1,
      image: "/assets/guide/auth/profile/link_new_ign_filled.png",
      description:
        "Enter your character name and click the 'Link IGN(s)' button.",
    },
    {
      title: "Hover Actions",
      level: 1,
      parentId: 1,
      image: "/assets/guide/auth/profile/linked_ign_hover_actions.png",
      description: "Hover over your linked IGN(s) to see management options.",
    },
    {
      title: "Editing IGNs",
      level: 1,
      parentId: 1,
      image: "/assets/guide/auth/profile/linked_ign_hover_edit.png",
      description: "Need to change a typo? Use the edit feature.",
    },
    {
      title: "Deleting IGNs",
      level: 1,
      parentId: 1,
      image: "/assets/guide/auth/profile/linked_ign_hover_delete.png",
      description: "Remove outdated or incorrect character names.",
    },
    { title: "Clan Management", level: 0, isHeader: true, id: 7 },
    {
      title: "Clan Creation",
      level: 1,
      parentId: 7,
      image: "/assets/guide/auth/profile/create_new_clan.png",
      description:
        "Click the 'CREATE NEW CLAN' button to initialize the setup process for a new clan.",
    },
    {
      title: "Clan Setup",
      level: 1,
      parentId: 7,
      image: "/assets/guide/auth/profile/create_new_clan_filled.png",
      description: "Input your clan name to finalize the creation.",
    },
  ];

  const toggleSection = (id) =>
    setExpandedSections((prev) => ({ ...prev, [id]: !prev[id] }));

  const navigate = (direction) => {
    let nextIndex = stepIndex + direction;
    while (nextIndex >= 0 && nextIndex < steps.length) {
      if (!steps[nextIndex].isHeader) {
        setStepIndex(nextIndex);
        let current = steps[nextIndex];
        let pathIds = [];
        while (current.parentId) {
          pathIds.push(current.parentId);
          current = steps.find((s) => s.id === current.parentId);
        }
        pathIds.push(current.id);
        const newExpanded = { 0: false, 1: false, 7: false };
        pathIds.forEach((id) => (newExpanded[id] = true));
        setExpandedSections(newExpanded);
        return;
      }
      nextIndex += direction;
    }
  };

  const currentStep = steps[stepIndex];

  return (
    <div className="guide-layout">
      <nav className="sub-nav">
        {steps.map((step, idx) => {
          const isHeader = !!step.isHeader;
          const isVisible = step.level === 0 || expandedSections[step.parentId];

          return (
            <div
              key={idx}
              className={`nav-item-wrapper ${stepIndex === idx ? "active" : ""}`}
              style={{
                maxHeight: isVisible ? "60px" : "0px",
                opacity: isVisible ? 1 : 0,
              }}
            >
              <span
                className={`sub-nav-item level-${step.level} ${isHeader ? "sub-nav-header" : ""}`}
                onClick={() =>
                  isHeader ? toggleSection(step.id) : setStepIndex(idx)
                }
              >
                {isHeader && (
                  <span
                    style={{
                      marginRight: "8px",
                      transform: expandedSections[step.id]
                        ? "rotate(90deg)"
                        : "rotate(0deg)",
                      transition: "transform 0.2s",
                    }}
                  >
                    <ChevronRight size={16} />
                  </span>
                )}
                {step.title}
              </span>
            </div>
          );
        })}
      </nav>

      <main className="guide-main">
        <div className="guide-item">
          <div className="guide-text">
            <h2>{currentStep.title}</h2>
            <div className="nav-controls">
              <button disabled={stepIndex === 0} onClick={() => navigate(-1)}>
                Back
              </button>
              <button
                disabled={stepIndex === steps.length - 1}
                onClick={() => navigate(1)}
                style={{ marginLeft: "10px" }}
              >
                {stepIndex === steps.length - 1 ? "Finish" : "Next"}
              </button>
            </div>
            {!currentStep.isHeader && (
              <div className="guide-text-wrapper">
                <p className="step-description">{currentStep.description}</p>
              </div>
            )}
          </div>
          {!currentStep.isHeader && (
            <div className="screenshot-container">
              <img src={currentStep.image} alt={currentStep.title} />
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default ProfileSection;
